import { TagsInput } from '@mantine/core';
import { useDispatch, useSelector } from 'react-redux';
import useFetch from '../helpers/useFetch';
import { setDomain } from '../store/domainSlice';

const TagsSelect = ({ model, handleChange, setUserError, isCampaignEditLocked }) => {
  const domain = useSelector((state) => state.domain.domain);
  const dispatch = useDispatch();
  const fetch = useFetch();

  const addTag = (tag) => {
    return new Promise((resolve, reject) => {
      if (tag && typeof tag.name === 'string' && !tag.id) {
        fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/tags`, {
          method: 'POST',
          body: JSON.stringify(tag),
        })
          .then((response) => {
            const newDomain = { ...domain };
            newDomain.availableTags = [...newDomain.availableTags];
            newDomain.availableTags.push(response.tag);
            dispatch(setDomain(newDomain));
            return resolve(response.tag);
          })
          .catch((error) => {
            return reject(error);
          });
      } else {
        return resolve(tag);
      }
    });
  };

  const onTagsChange = (tags) => {
    const newTag = tags.find((t) => !model.tags.map((modelTag) => modelTag.id).includes(t.id));
    if (newTag) {
      addTag(newTag)
        .then((tag) => {
          handleChange({
            target: { name: 'tags', value: [...tags.filter((t) => t.name !== tag.name), tag].filter((t) => !!t) },
          });
        })
        .catch(setUserError);
    } else {
      handleChange({ target: { name: 'tags', value: tags } });
    }
  };

  const handleTagsInputChange = (values) => {
    const processed = values.map((value) => {
      const existingTag = domain.availableTags.find((tag) => tag.name === value);
      if (existingTag) {
        return existingTag;
      }
      return { name: value };
    });
    onTagsChange(processed);
  };

  return (
    <TagsInput
      disabled={isCampaignEditLocked}
      clearable
      value={model.tags.map((tag) => tag.name)}
      data={domain.availableTags.map((tag) => tag.name)}
      onChange={handleTagsInputChange}
    />
  );
};

export default TagsSelect;
